import React from 'react'

const Jteam = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="bg11  my-3">
                    <div className="md:w-[56%]  w-full md:left-[25%]   top-0 bottom-0 relative">
                        <div className="md:mx-0 mx-4">
                            <div className="py-14">
                                <h1 className='text-[2.5rem] font-black text-[#004A8B]'>Join our team</h1>
                                <h1 className='border-b-[.4rem] border-[#B5D1B3] w-[3.5rem]'></h1>
                            </div>
                            <div className="">
                                <p className='md:text-[1.5rem] text-[1.2rem] font-black text-[#004A8B] tracking-wider leading-8'>
                                    At LAWD you will have the opportunity to work alongside some of the most respected names in the property industry.
                                </p>

                                <p className='py-5 leading-7 tracking-wider'>
                                    With offices based in Brisbane, Melbourne, Sydney and Perth, our team is often travelling across the country working on some of Australia’s most significant real estate assets and transactions.
                                </p>
                                <p className='py-5 leading-7 tracking-wider'>
                                    As a privately owned company, we nurture and value our team, which is why we’ve rapidly grown to more than 50 highly skilled professionals since our launch in 2020.
                                </p>
                                <p className='py-5 leading-7 tracking-wider'> As a company that is driven to be innovative, we also support those who promote leadership and innovation, and participate in events including the Global Food Forum, evokeAG. and Beef Australia.</p>
                            </div>
                            
                        </div>

                        <div className="py-10">    
                            <button className='border tracking-wider py-3 md:mx-0 mx-4 border-[#004a8b] text-[#004a8b] px-5  text-[13px] hover:border-[#B5D1B3] hover:bg-[#B5D1B3] hover:text-[black]'>EMPLOYEMENT EXPRESSION ON INTEREST</button>
                        </div>

                    </div>



                </div>
            </div>

        </>
    )
}

export default Jteam